export const TIME_PERIODS = ['morning', 'afternoon', 'evening'];

export const TIME_PERIOD_PREDICATES = [
  (dateHours: number) => dateHours < 12,
  (dateHours: number) => dateHours < 17 && dateHours >= 12,
  (dateHours: number) => dateHours >= 17,
];
